import { useQuery } from '@tanstack/react-query';
import {CACHE_STALE_TIME_MINS} from "@/lib/constants.ts";
import reitService from "@/services/investments/reit/ReitService.ts";

/**
 * Custom hook that retrieves REIT (Real Estate Investment Trust) types using a query.
 *
 * This hook leverages the `useQuery` function to fetch a list of REIT types from the service.
 * The query key is set to `['reit_types']` and utilizes a specific cache stale time.
 *
 * @return {UseQueryResult} The result object returned from the query, including the data, loading state, and other query metadata.
 */
export default function useFetchReitTypes() {
  return useQuery({
    queryKey: ['reit_types'],
    queryFn: async () => {
      return await reitService.getTypes()
    },
    staleTime: CACHE_STALE_TIME_MINS,
  });
}
